import React from 'react';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

const DEFAULT_OPTIONS = ['16:9', '9:16'];

const DESCRIPTORS = {
  '16:9': {
    label: 'Landscape',
    previewClassName: 'h-6 w-10',
    description: 'Landscape format for CTV and desktop',
  },
  '9:16': {
    label: 'Portrait',
    previewClassName: 'h-8 w-5',
    description: 'Portrait format for mobile and social',
  },
};

export default function AspectRatioSelector({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  disabled = false,
  label = 'Aspect ratio',
  className,
}) {
  const effectiveOptions = options.length > 0 ? options : DEFAULT_OPTIONS;
  const resolvedValue = value || effectiveOptions[0] || '16:9';

  if (effectiveOptions.length === 1) {
    const descriptor = DESCRIPTORS[resolvedValue];

    return (
      <div className={cn('space-y-2', className)}>
        <Label className="text-sm font-medium">{label}</Label>
        <div className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
          <p className="text-sm text-slate-700">{descriptor?.description || `Generating a ${resolvedValue} video`}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={cn('space-y-2', className)}>
      <Label className="text-sm font-medium">{label}</Label>
      <div className="grid grid-cols-2 gap-3">
        {effectiveOptions.map((option) => {
          const descriptor = DESCRIPTORS[option];
          const isSelected = resolvedValue === option;

          return (
            <button
              key={option}
              type="button"
              disabled={disabled}
              className={cn(
                'flex items-center justify-center gap-2 rounded-xl border-2 px-4 py-3 text-sm font-medium transition-all',
                isSelected
                  ? 'border-coral bg-coral/5 text-coral shadow-sm'
                  : 'border-border text-muted-foreground hover:border-muted-foreground/30',
                disabled && 'cursor-not-allowed opacity-60',
              )}
              onClick={() => onChange?.(option)}
            >
              <div className={cn('rounded border-2 border-current bg-background', descriptor?.previewClassName)} />
              <span>{descriptor?.label || option}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
